import type { OneDriveMigrationStatus } from '@/types/oscar';

/**
 * Status pill for a OneDrive-to-Vault migration (PR-33), shared by the
 * Offboarding Status page and the People Detail profile. `null` renders the
 * "Not migrated" neutral state (no row exists for the person yet).
 */
const badge: Record<OneDriveMigrationStatus, string> = {
  Pending: 'bg-lightBlue/10 text-lightBlue',
  Copied: 'bg-green/10 text-green',
  Failed: 'bg-red/10 text-red',
  // Terminal, nothing-to-do (locked / no drive) — neutral, not a red failure.
  Skipped: 'bg-darkGrey/10 text-darkGrey/70',
};

export function OneDriveMigrationBadge({ status }: { status: OneDriveMigrationStatus | null }) {
  if (!status) {
    return (
      <span className="inline-flex rounded-full bg-darkGrey/10 px-2 py-0.5 text-xs font-semibold text-darkGrey/70">
        Not migrated
      </span>
    );
  }
  return (
    <span className={`inline-flex rounded-full px-2 py-0.5 text-xs font-semibold ${badge[status]}`}>
      {status}
    </span>
  );
}
